import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ModalService } from 'projects/app-shared/src/public-api';
import { MarianomGeneral } from '../../marianom-general.service';
import { EcommerceGenericoService, TurnosRetiroEccomerce } from 'projects/ecommerce-generico/src/public-api';
import * as moment from 'moment';
import 'moment/locale/es';

@Component({
  selector: 'modal-calendario-modal-mmax',
  templateUrl: './modal-calendario-mmax.component.html',
  styleUrls: ['./modal-calendario-mmax.component.scss']
})

export class ModalCalendarioMmaxComponent implements OnInit {
  week: any = [
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
    "Domingo"
  ];
  fechaMin: moment.Moment;
  fechaMax: moment.Moment;
  monthSelect: any[] = [];
  dateSelect: any;
  dateValue: any;
  today: any; // Esto almacena la fecha de hoy en el formato 'YYYY-MM-DD'
  turnoselecionado: TurnosRetiroEccomerce;
  carrito:any[] = [];
  articuloNoCumple: boolean = false; 

  constructor(private modal: ModalService, private genServ:EcommerceGenericoService, private serv:MarianomGeneral, private cdr: ChangeDetectorRef) {
    moment.locale('es');
  }

  ngOnInit(): void {
    console.log("Inicializando el calendario modal de Mariano Max", this);
    
    this.today = moment(); 
    this.calcularRangoFechas();
    const currentMonth = this.today.month() + 1; 
    const currentYear = this.today.year(); 
    this.getDaysFromDate(currentMonth, currentYear);
    this.genServ.getPedidoWeb().subscribe(
      (data) => {
        this.carrito = (data as any)?.registros; 
        this.articuloNoCumple = this.carrito.some((articulo, i) => {
          return articulo.categoria !== 1;
        });
        this.getDaysFromDate(currentMonth, currentYear);
        this.cdr.detectChanges();
      },
      (error) => {
        console.error('Error al obtener el pedido:', error);
      }
    );
    console.log("esto es el calendario: ", this);
    
  }

  calcularRangoFechas(): void {
      this.fechaMin = this.today.clone().add(1, 'days');
      // Establece fechaMax como fechaMin + 1 semana
      this.fechaMax = this.today.clone().add(1, 'week').endOf('isoWeek'); 
  
  }

  cancelar() {
    this.modal.closeAll();
  }

  confirmarAgenda() {
    this.turnoselecionado={
      agendado: 0,
      dia: this.dateValue.date(),
      fecha: this.dateValue.format('YYYY-MM-DD'),
      horafin: 18,
      horainicio: 9,
      limiteentrega: 0,
      modo: 1, //"Retiro;0|Reparto;1"
      sucursal: 0, 
    }
    this.serv.setTurno(this.turnoselecionado)
    //console.log("Se eligio una fecha de entrega: ",this.dateValue.format('YYYY-MM-DD'));
    this.modal.close('elegir-entrega-modal-4');
    this.modal.open('confirmar-checkout-modal-1');
  }

  // Esta función obtiene los días del mes seleccionado
  getDaysFromDate(month, year) {
    const startDate = moment(`${year}/${month}/01`).startOf('day');
    const endDate = startDate.clone().endOf('month').startOf('day');
    this.dateSelect = startDate;

    // Obtener el número exacto de días del mes
    const numberDays = startDate.daysInMonth();

    // Generar los días del mes correctamente
    const arrayDays = Array.from({ length: numberDays }, (_, i) => {
      const dayNumber = i + 1;
      const dayObject = moment(`${year}-${month}-${dayNumber}`, 'YYYY-MM-DD');

      return {
        name: dayObject.format("dddd"),
        value: dayNumber,
        indexWeek: dayObject.isoWeekday(),
        isToday: dayObject.isSame(this.today, 'day'), // Compara el día con hoy
        isSelected: false, // Marcar el día como no seleccionado inicialmente
        isDisabled: dayObject.startOf('day').isBefore(this.today.startOf('day')) || [6, 7].includes(dayObject.isoWeekday()) || 
        dayObject.startOf('day').isBefore(this.fechaMin.startOf('day')) || 
        dayObject.startOf('day').isAfter(this.fechaMax.startOf('day'))
      };
    });

    this.monthSelect = arrayDays;
    //console.log("Mes días:", this.monthSelect);
  }

  // Función para cambiar de mes
  changeMonth(flag) {
    if (flag < 0) {
      const prevDate = this.dateSelect.clone().subtract(1, "month");
      this.getDaysFromDate(prevDate.format("MM"), prevDate.format("YYYY"));
    } else {
      const nextDate = this.dateSelect.clone().add(1, "month");
      this.getDaysFromDate(nextDate.format("MM"), nextDate.format("YYYY"));
    }
  }

  // Función para seleccionar un día
  clickDay(day) {
    // Desmarcar cualquier día previamente seleccionado
    this.monthSelect.forEach(d => d.isSelected = false);

    day.isSelected = true;

    const monthYear = this.dateSelect.format('YYYY-MM');
    const parse = `${monthYear}-${day.value}`;
    const objectDate = moment(parse);
    this.dateValue = objectDate;
    console.log("Esto es la fecha seleccionada: ",this.dateValue.format('YYYY-MM-DD'));
    
  }
}